import { useState, useEffect } from "react";
import moment from "moment";
import InputDate from "../../components/form/InputDate";
import Select from "../../components/form/select/Select";
import ModalDefault from "../../components/ModalDefault";
import api from "../../services/api";
import message from "../../services/message";
import axios from "axios";
import { Container } from "../../styles/layout";
import {
  IconAdd,
  IconArrow,
  IconDetails,
  IconEdit,
  IconFilter,
  IconRemove,
} from "../../components/layout/Svgs";

import {
  HeaderPonto,
  SectionFilterPonto,
  SectionTablePonto,
  SectionDetailsPonto,
  SectionRegisterPonto,
  ContainerPonto,
} from "./styles";
import ButtonDownload from "../../components/form/ButtonDownload/ButtonDownload";
import { ContainerModal, SectionModal } from "../../components/layout/styles";
import Input from "../../components/form/input/Input";


export default function TiposPagamentosListar() {

  const [load, setLoad] = useState(false);
  const [modal, setModal] = useState(false);

  const [contas, setContas] = useState([])
  const [newConta, setNewConta] = useState({
    contaId: null,
    nome:'',
    status:'ativo'
  })

  useEffect(() => {
    getContas()
  }, [])

  async function getContas(){
    try{
      let response : any =  await api.get(`/conta`)
      setContas(response.data)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function resetConta(){
    setNewConta({
      contaId: null,
      nome:'',
      status:'ativo'
    })

    setModal(!modal)
  }

  function handleOnChangeNewConta(name: string, value: string) {
    if (value) {
      setNewConta({ ...newConta, [name]: value });
    } else {
      setNewConta({ ...newConta, [name]: ''});
    }
  }

  async function editarConta(id?: any) {
    try{
      if(id){
        let response = await api.get(`/conta/${id}`)
        setNewConta(response.data)
      }else{
        resetConta()
      }
      
      setModal(true);
    } catch(error: any) {
      message.error(String(error?.response?.data?.message));
    }
  }

  async function saveConta(e:any){
    try{
      e.preventDefault();
      let response : any
      if(newConta.contaId){
        response = await api.put(`/conta/${newConta.contaId}`,newConta)
        message.success(`Conta Editada com Sucesso.`)
      }else{
        response = await api.post(`/conta`, newConta)
        message.success(`Conta Criada com sucesso`)
      }
      await getContas()
      resetConta()
      setModal(!modal)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function excluirConta(id:number){
    try{
      let response : any = await api.delete(`/conta/${id}`)
      getContas()

      message.success(`Conta Excluida com Sucesso.`)
    
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }


  return (
    <Container>
      <HeaderPonto>
        <h1 className="titlePonto">Contas</h1>
        <button
          style={{ margin: "0px", width: "100px", letterSpacing: "1px",verticalAlign:'middle' }}
          className="btn btn-primary"
          onClick={() => editarConta()}
        > 
          Adicionar 
          <i className="fa-solid fa-plus"></i>
        </button>
      </HeaderPonto>

      <SectionTablePonto>
        <table className="default">
          <thead>
            <tr>
              <th>Conta</th>
              <th>Editar</th>
              <th>Remover</th>
              
            </tr>
          </thead>

          <tbody>
            { contas && contas.length > 0 &&
                contas.map((row:any, key:any) =>(
              
                  <tr key={key}>
          
                    <td>{row.nome}</td>
                    <td>
                      <button
                        className="btn"
                        onClick={() => editarConta(row.contaId)}
                      >
                        <IconEdit />
                      </button>
                    </td>
                    <td>
                      <button
                        className="btn"
                        onClick={() => excluirConta(row.contaId)}
                      >
                        <IconRemove />
                      </button>
                    </td>
                  </tr>
                ))
              }
          </tbody>
        </table>
      </SectionTablePonto>
      <ModalDefault
        id="modalDefault"
        onClose={() => resetConta()}
        visible={modal}
      >
        <ContainerModal>
          <SectionModal>
            <h1>Editar / Adicionar - Conta</h1>
            <form onSubmit={saveConta}>
              <div className="field">
                <h4>Nome</h4>
                <div className="input">
                  <Input type="text" name="nome" value={newConta?.nome} onChange={handleOnChangeNewConta}/>
                </div>
              </div>


              <div className="actions">
                <button type="submit" className="btn btn-success">Salvar</button>
                <button type="button"  onClick={() => resetConta()} className="btn btn-danger">Voltar</button>
              </div>
            </form>
          </SectionModal>
            <button
              className="buttonClosePreview"
              onClick={() => resetConta()}
            >
              <IconRemove width="22px" height="22px" />
              Fechar modal
            </button>
          
        </ContainerModal>
      </ModalDefault>
    </Container>
  );
}
